<h5>{{ "Template.DeliveryConditionsComponent.subHeader_deliveryConditions" | translate }}</h5>

<h6>{{ "Template.DeliveryConditionsComponent.subHeader_forZrOrders" | translate }}</h6>

<p>
  <small>{{ "Template.DeliveryConditionsComponent.text_explanation" | translate }}</small>
</p>

@if (loading) {
  <div class="text-center">
    <fa-icon icon="spinner" animation="spin" size="2x"></fa-icon>
  </div>
}

@if (!loading) {
  <form [formGroup]="deliveryConditionsForm" novalidate>
    <div class="form-group mb-2">
      <label for="deliveryMinimumLimit" class="mb-0">{{ "Template.DeliveryConditionsComponent.label_minimumOrderValue" | translate }}</label>
      <div class="input-group input-group-sm">
        <span class="input-group-text">€</span>
        <input type="number" [class]="deliveryConditionsForm.controls['deliveryMinimumLimit'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="deliveryMinimumLimit" placeholder="0,00" step="0.01" />
      </div>
    </div>
    <div class="form-group mb-2">
      <label for="deliveryNormalLimit" class="mb-0">{{ "Template.DeliveryConditionsComponent.label_freeShippingLimit" | translate }}</label>
      <div class="input-group input-group-sm">
        <span class="input-group-text">€</span>
        <input type="number" [class]="deliveryConditionsForm.controls['deliveryNormalLimit'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="deliveryNormalLimit" placeholder="0,00" step="0.01" />
      </div>
    </div>
    <div class="form-group mb-2">
      <label for="minimumQuantitySurcharge" class="mb-0">{{ "Template.DeliveryConditionsComponent.label_minimumQuantitySurcharge" | translate }}</label>
      <div class="input-group input-group-sm">
        <span class="input-group-text">€</span>
        <input type="number" [class]="deliveryConditionsForm.controls['minimumQuantitySurcharge'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="minimumQuantitySurcharge" placeholder="0,00" step="0.01" />
      </div>
    </div>
    <div class="form-group mb-2">
      <label for="deliveryNotes" class="mb-0">{{ "Template.DeliveryConditionsComponent.label_furtherNotes" | translate }}</label>
      <textarea [class]="deliveryConditionsForm.controls['deliveryNotes'].disabled ? 'form-control form-control-plaintext' : 'form-control'" formControlName="deliveryNotes" placeholder="{{ 'Template.DeliveryConditionsComponent.placeholder_furtherNotes' | translate }}"></textarea>
    </div>
    <button class="btn btn-sm btn-block w-100" (click)="showForm(!deliveryConditionsForm.controls['editing'].value)" type="button" [class]="deliveryConditionsForm.controls['editing'].value ? 'btn-outline-danger' : 'btn-secondary'">
      @if (!deliveryConditionsForm.controls['editing'].value) {
        <span>{{ "Template.DeliveryConditionsComponent.btn_edit" | translate }}</span>
      }
      @if (deliveryConditionsForm.controls['editing'].value) {
        <span>{{ "Common.btn_cancel" | translate }}</span>
      }
      @if (!deliveryConditionsForm.controls['editing'].value) {
        <fa-icon icon="pencil-alt" class="ms-1"></fa-icon>
      }
      @if (deliveryConditionsForm.controls['editing'].value) {
        <fa-icon icon="circle-xmark" class="ms-1"></fa-icon>
      }
    </button>
    @if (deliveryConditionsForm.controls['editing'].value) {
      <button type="button" [attr.disabled]="saving ? '' : null" class="btn btn-secondary btn-sm mt-2 btn-block w-100" (click)="saveDeliveryConditions()">
        {{ "Template.DeliveryConditionsComponent.btn_save" | translate }}
        @if (!saving) {
          <fa-icon icon="check" class="ms-1"></fa-icon>
        }
        @if (saving) {
          <fa-icon icon="spinner" animation="spin" class="ms-1"></fa-icon>
        }
      </button>
    }
  </form>
}
